import {Component, OnInit, OnChanges, Output, EventEmitter, Input, inject} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { AudienceService } from 'src/app/core/services/api/audience.service';
import { ObjectivesService } from 'src/app/core/services/api/objectives.service';
import { TypePublicService } from 'src/app/core/services/api/type-public.service';

interface Rate {
    title: string;
    value: number;
    /** Estrella sobre la que está el cursor, solo para la vista previa */
    hover?: number;
}

@Component({
    selector: 'app-rate-campaign',
    templateUrl: './rate-campaign.component.html',
    styleUrls: ['./rate-campaign.component.scss']
})
export class RateCampaignComponent implements OnInit, OnChanges {

    @Output() onRate = new EventEmitter<any>();
    @Input() data: any;
    @Input() weight: boolean;

    /** Estrellas a mostrar por criterio */
    readonly stars = [1, 2, 3, 4, 5];

    /** Nombre de cada nivel, indexado por su valor (0 = sin valorar) */
    readonly levels = ['Sin valorar', 'Muy malo', 'Malo', 'Regular', 'Bueno', 'Muy bueno'];

    /** Avisa lo que falta apenas se abre la pestaña, sin esperar a que se toque el campo */
    readonly mostrarSiempre: ErrorStateMatcher = {
        isErrorState: (control: AbstractControl | null) => !!control?.invalid
    };

    rateCampaign: { name: string; rates: Rate[] }[] = [
        {
            name: 'Noticia',
            rates: [
                {title: 'Interes Público', value: 0},
                {title: 'Nivel de Novedad', value: 0},
                {title: 'Nivel de Actualidad', value: 0}
            ]
        },
        {
            name: 'Cliente',
            rates: [
                {title: 'Nivel de Autoridad', value: 0},
                {title: 'Nivel de Popularidad', value: 0}
            ]
        },
        {
            name: 'Voceros',
            rates: [
                {title: 'Nivel de Autoridad', value: 0},
                {title: 'Nivel de Popularidad', value: 0}
            ]
        }
    ]

    campaignValor: { title: string; value: number; options: any }[] = [
        {
            title: 'Objetivo',
            value: null,
            options: null
        },
        {
            title: 'Público Objetivo',
            value: null,
            options: null
        },
        {
            title: 'Audiencia',
            value: null,
            options: null
        }
    ]

    objectivesService = inject(ObjectivesService);
    typePublicService = inject(TypePublicService);
    audienceService = inject(AudienceService);

    ngOnInit(): void {
        this.objectivesService.getAll()
        .subscribe(response => {
            const { data: objectives } = response;
            this.campaignValor[0].options = objectives;
        });
        this.typePublicService.getAll()
        .subscribe(response => {
            const { data: typePublic } = response;
            this.campaignValor[1].options = typePublic;
        });
        this.audienceService.getAll()
        .subscribe(response => {
            const { data: audience } = response;
            this.campaignValor[2].options = audience;
        });
    }

    ngOnChanges() {
        if (this.data) {
            this.campaignValor[0].value = this.data.tipoObjetivo;
            this.campaignValor[1].value = this.data.tipoPublico;
            this.campaignValor[2].value = this.data.tipoAudiencia;
            this.rateCampaign[0]['rates'][0].value = this.data.interesPublico ? this.data.interesPublico : 0;
            this.rateCampaign[0]['rates'][1].value = this.data.novedad ? this.data.novedad : 0;
            this.rateCampaign[0]['rates'][2].value = this.data.actualidad ? this.data.actualidad : 0;
            this.rateCampaign[1]['rates'][0].value = this.data.autoridadCliente ? this.data.autoridadCliente : 0;
            this.rateCampaign[1]['rates'][1].value = this.data.mediaticoCliente ? this.data.mediaticoCliente : 0;
            this.rateCampaign[2]['rates'][0].value = this.data.autoridadVoceros ? this.data.autoridadVoceros : 0;
            this.rateCampaign[2]['rates'][1].value = this.data.mediaticoVoceros ? this.data.mediaticoVoceros : 0;
        }
    }

    /**
     * Marca el criterio con la estrella elegida.
     * Volver a hacer clic en la estrella activa deja el criterio sin valorar.
     */
    setRate(rate: Rate, value: number) {
        rate.value = rate.value === value ? 0 : value;
        this.onChange();
    }

    /** Estrellas que se pintan llenas: las del cursor si lo hay, si no las del valor guardado */
    shownRate(rate: Rate): number {
        return rate.hover ?? rate.value;
    }

    onChange() {
        this.emitInfo();
    }

    emitInfo() {
        const data = {
            tipoPublico: this.campaignValor[1].value,
            tipoObjetivo: this.campaignValor[0].value,
            tipoAudiencia: this.campaignValor[2].value,
            interesPublico: this.rateCampaign[0]['rates'][0].value,
            novedad: this.rateCampaign[0]['rates'][1].value,
            actualidad: this.rateCampaign[0]['rates'][2].value,
            autoridadCliente: this.rateCampaign[1]['rates'][0].value,
            mediaticoCliente: this.rateCampaign[1]['rates'][1].value,
            autoridadVoceros: this.rateCampaign[2]['rates'][0].value,
            mediaticoVoceros: this.rateCampaign[2]['rates'][1].value
        }
        this.onRate.emit(data);
    }

}
